import React from 'react';
import { AreaPriceRow } from '../../types';
import { D3LineChart } from './D3LineChart';

interface AreaPriceLineChartProps {
  data: AreaPriceRow[];
  colorScaleFunc?: (value: number) => string;
}

const AREA_TIER_ORDER: Record<string, number> = {
  '0-30m²': 1,
  '30-50m²': 2,
  '50-70m²': 3,
  '70-100m²': 4,
  '100-150m²': 5,
  '150-200m²': 6,
  '200-300m²': 7,
  '300+m²': 8,
};

const getAreaMidpoint = (tier: string): number => {
  const match = tier.match(/(\d+)-(\d+)m²/);
  if (match) {
    const [, min, max] = match;
    return (parseInt(min) + parseInt(max)) / 2;
  }
  if (tier === '300+m²') return 350;
  return 0;
};

export const AreaPriceLineChart: React.FC<AreaPriceLineChartProps> = ({ data, colorScaleFunc }) => {
  const series = (data || [])
    .filter((d) => d.avg_area > 0 && d.avg_price_per_m2 > 0)
    .map((d) => ({
      tier: d.area_tier,
      order: AREA_TIER_ORDER[d.area_tier] || 0,
      key: getAreaMidpoint(d.area_tier),
      value: d.avg_price_per_m2,
    }))
    .sort((a, b) => a.order - b.order);

  return (
    <D3LineChart
      data={series}
      title="Preço por m² vs Tamanho"
      xLabel="Tamanho (m²)"
      yLabel="Preço por m² (R$)"
      formatXTick={(k) => `${Math.round(Number(k))}m²`}
      formatYTick={(n) => `R$${Math.round(n)}`}
      colorScaleFunc={colorScaleFunc}
    />
  );
};
